import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ButtonComponent } from './components/button/button.component';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './pages/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { CadastrosComponent } from './pages/cadastros/cadastros.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { FeedComponent } from './pages/feed/feed.component';
import { IntranetDashComponent } from './pages/intranet-dash/intranet-dash.component';
import { PostEditorComponent } from './pages/post-editor/post-editor.component';
import { ControlsignComponent } from './pages/controlsign/controlsign.component';
import { ControltaskComponent } from './pages/controltask/controltask.component';
import { ControlMentorComponent } from './pages/controlmentor/controlmentor.component';
import { ControlDocsComponent } from './pages/controldocs/controldocs.component';
import { ControldocsShareComponent } from './pages/controldocs-share/controldocs-share.component';
import { ControlcliComponent } from './pages/controlcli/controlcli.component';
import { ControlhelpComponent } from './pages/controlhelp/controlhelp.component';
import { ControlprojectComponent } from './pages/controlproject/controlproject.component';
import { ControlflowComponent } from './pages/controlflow/controlflow.component';
import { ControlflowEditorComponent } from './pages/controlflow-editor/controlflow-editor.component';
import { ControlsafeComponent } from './pages/controlsafe/controlsafe.component';
import { ControlquestionComponent } from './pages/controlquestion/controlquestion.component';
import { ControlquestionPublicComponent } from './pages/controlquestion-public/controlquestion-public.component';
import { ControlquestionIntranetComponent } from './pages/controlquestion-intranet/controlquestion-intranet.component';
import { ControlaiComponent } from './pages/controlai/controlai.component';
import { ControldpComponent } from './pages/controldp/controldp.component';
import { ControlopComponent } from './pages/controlop/controlop.component';
import { ControlbordoComponent } from './pages/controlbordo/controlbordo.component';
import { ControlchatWidgetComponent } from './components/controlchat-widget/controlchat-widget.component';
import { ControlchatV2WidgetComponent } from './components/controlchat-v2-widget/controlchat-v2-widget.component';
import { ControlchatDesktopComponent } from './pages/controlchat-desktop/controlchat-desktop.component';
import { DesktopDownloadComponent } from './pages/desktop-download/desktop-download.component';
import { DigitalAdmissionComponent } from './pages/digital-admission/digital-admission.component';
import { ControlsocialComponent } from './pages/controlsocial/controlsocial.component';
import { ControlmonitorComponent } from './pages/controlmonitor/controlmonitor.component';
import { MystoreComponent } from './pages/mystore/mystore.component';
import { ControlDossieComponent } from './pages/controldossie/controldossie.component';
import { ControlinventoryComponent } from './pages/controlinventory/controlinventory.component';

//ANGULAR MATERIAL
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BR_DATE_FORMATS, BrDateAdapter } from './utils/br-date-adapter';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    ButtonComponent,
    LoginComponent,
    HomeComponent,
    MenuComponent,
    CadastrosComponent,
    ActivationComponent,
    FeedComponent,
    IntranetDashComponent,
    PostEditorComponent,
    ControlsignComponent,
    ControltaskComponent,
    ControlMentorComponent,
    ControlDocsComponent,
    ControldocsShareComponent,
    ControlcliComponent,
    ControlhelpComponent,
    ControlprojectComponent,
    ControlflowComponent,
    ControlflowEditorComponent,
    ControlsafeComponent,
    ControlquestionComponent,
    ControlquestionPublicComponent,
    ControlquestionIntranetComponent,
    ControlaiComponent,
    ControldpComponent,
    ControlopComponent,
    ControlbordoComponent,
    ControlchatWidgetComponent,
    ControlchatV2WidgetComponent,
    ControlchatDesktopComponent,
    DigitalAdmissionComponent,
    DesktopDownloadComponent,
    ControlsocialComponent,
    ControlmonitorComponent,
    MystoreComponent,
    ControlDossieComponent,
    ControlinventoryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTabsModule,
    MatBadgeModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    BaseChartDirective
  ],
  providers: [
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideCharts(withDefaultRegisterables()),
    { provide: DateAdapter, useClass: BrDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: BR_DATE_FORMATS },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
